import { EventEmitter, Injectable, Output } from '@angular/core';
import { ContentItem } from '@edassist/api';

@Injectable({
    providedIn: 'root'
})
export class EdMarketPlaceSurveyService {
    @Output() readonly showExplorationSurveyEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() readonly explorationSurveyContentEvent: EventEmitter<Array<ContentItem>> =
                                            new EventEmitter<Array<ContentItem>>();

    handleShowExplorationSurveyModal(): void {
        this.showExplorationSurveyEvent.emit(true);
    }

    handleHideExplorationSurveyModal(): void {
        this.showExplorationSurveyEvent.emit(false);
    }

    handleExplorationSurveyContent(explorationSurvey: Array<ContentItem>): void {
        this.explorationSurveyContentEvent.emit(explorationSurvey);
    }
}